// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"_3_oKR","footer":"_1Q2Gj","buttons":"_2_-fW","button":"_3p8Sf"};